var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideBarCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5535",
    "data-name": "Group 5535",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67650",
    "data-name": "Path 67650",
    d: "M25.333,2.667H24V1.333a1.333,1.333,0,1,0-2.667,0V2.667H10.667V1.333A1.333,1.333,0,0,0,8,1.333V2.667H6.667A6.675,6.675,0,0,0,0,9.333v16A6.675,6.675,0,0,0,6.667,32H25.333A6.675,6.675,0,0,0,32,25.333v-16A6.675,6.675,0,0,0,25.333,2.667ZM2.667,9.333a4,4,0,0,1,4-4H25.333a4,4,0,0,1,4,4v1.333H2.667Zm22.667,20H6.667a4,4,0,0,1-4-4v-12H29.333v12A4,4,0,0,1,25.333,29.333Z",
    fill: "#3160d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(14 18)",
    fill: "#3160d4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(7.334 18)",
    fill: "#3160d4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(20.666 18)",
    fill: "#3160d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarCalendar);
export default __webpack_public_path__ + "static/media/sideBarCalendar.d9e9bceee677ccdb8732b2e62691a302.svg";
export { ForwardRef as ReactComponent };